<template>
  <shipment-tracking />
</template>

<script>
import ShipmentTracking from "@/components/Ondemand/Bookings/ShipmentTracking.vue";

export default {
  components: {
    ShipmentTracking,
  },
};
</script>

<style></style>
